<template>
  <tr>
    <td>
      <img style="max-height: 50px; max-width: 75px;" :src="carImage"/>
      <br/>
      <router-link :to="`/fleet/vehicles/${box.Car.uuid}`">
        {{ box.Car.dropdownLabel }}
      </router-link>
    </td>
    <td>
      {{ box.serial }}
    </td>
    <td>
      {{ box.provider }}
    </td>
    <td>
      <span class="fa" :class="{
        'fa-check text-success': !box.problems,
        'fa-times text-danger': box.problems
      }"></span>
    </td>
    <td>
      {{ box.firmwareVersion }}
    </td>
    <td>
      {{ box.installer }}
    </td>
    <td>
      <router-link class="btn btn-primary btn-sm" :to="'/hardware/boxes/edit/' + box.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
export default {
  components: {
  },
  name: 'CarHardwareRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.box.Car.CarType.AmazonImage.objectKey
    },
    box () {
      return {
        Car: {
          CarType: {
            AmazonImage: {
              objectKey: 'spacer.gif'
            }
          }
        },
        ...this.object,
        ...this.updatedBox
      }
    }
  },
  data () {
    return {
      updatedBox: {}
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/CarHardware.vue